import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-add',
	path: '/secure/admin/AddNotification([!%]?[\\w]*).jspa',
};
